/**
 * Permission Rules Controller
 * Add / Edit Permission Rules
 */

import { find } from 'app/helpers/object'
import { getId } from '../../app/helpers/entity'

// controller mixins
AddPermissionRuleCtrl.mixes = [
  ['m2mCtrlMixin', 'rule', 'networks']
]

/**
 * AddPermissionRuleCtrl controller
 *
 * @class AddPermissionRuleCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/addSystemUserPermission.controller:AddPermissionRuleCtrl
 */
/* @ngInject */
export default function AddPermissionRuleCtrl ($scope, authSvc, Network, rule, $http) {
  var vm = this

  vm.APP_PRODUCT_TOUR_ENABLED = !!window.ENV.APP_PRODUCT_TOUR_ENABLED

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Current user
   *
   * @memberof mwApp/settings.controller:AddPermissionRuleCtrl
   * @type {models.User}
   */
  vm.me = authSvc.getUser()

  /**
   * Rule
   *
   * @memberof mwApp/settings.controller:AddPermissionRuleCtrl
   * @type {models.Rule}
   */
  vm.rule = rule

  // expanse plain rule's boolean flags to normal array with objects
  vm.expansedRule = [
    authSvc.hasEnabledFlag('FEATURE_SECURED_DASHBOARD_ENABLED') && {
      name: 'Dashboard',
      key: 'Dashboard'
    },
    {
      name: 'Organizations',
      key: 'Network',
      children: [
        {
          name: 'API Access',
          key: 'APIAccess'
        }, {
          name: 'Organization Settings',
          key: 'NetworkGeneral'
        }, {
          name: 'Tenant Settings',
          key: 'MultiorgSettings'
        }, {
          name: 'Monetization Plans',
          key: 'Subscription'
        }, {
          name: 'Discount Campaigns',
          key: 'DiscountCampaigns'
        }, {
          name: 'Announcements',
          key: 'Announcement'
        }, {
          name: 'Banner & Featured Carousels',
          key: 'BannerFeatured'
        }, {
          name: 'Payment Services',
          key: 'NetworkPayment'
        }, {
          name: 'Currencies',
          key: 'NetworkCurrency'
        }, authSvc.hasEnabledFlag('FEATURE_SHOPPING_CART_MANAGEMENT_ENABLED') && {
          name: 'Shopping Cart',
          key: 'ShoppingCart'
        }]
    },
    {
      name: 'Subscribers',
      key: 'Subscriber',
      children: [
        {
          name: 'Search results',
          key: 'Search'
        }, {
          name: 'Devices',
          key: 'SubscriberDevice'
        }, {
          name: 'Device Slots',
          key: 'DeviceSlot'
        }, {
          name: 'Activation',
          key: 'SubscriptionPayment'
        }, {
          name: 'Credit cards',
          key: 'SubscriberActivationCreditCard'
        }, {
          name: 'Custom Streams',
          key: 'SubscriberCustomStream'
        }, {
          name: 'Notes',
          key: 'SubscriberNote'
        }, {
          name: 'Subscriber\'s Library',
          key: 'SubscriberLibrary'
        }]
    },
    {
      name: 'Channels',
      key: 'Channel'
    },
    {
      name: 'Live Events',
      key: 'LiveEvent'
    },
    {
      name: 'Video On Demand',
      key: 'Vod'
    },
    {
      name: 'TV Shows',
      key: 'VodSeries'
    },
    {
      name: 'Categories',
      children: [
        {
          name: 'Channel Categories',
          key: 'TvChannelCategory'
        }, {
          name: 'VOD Categories',
          key: 'VodCategory'
        }, {
          name: 'TV Show Categories',
          key: 'TvShowCategory'
        }
      ]
    },
    {
      name: 'Channel Services',
      children: [
        {
          name: 'Catch-up TV',
          key: 'Catchup'
        },
        {
          name: 'Live Rewind',
          key: 'LiveRewind'
        },
        {
          name: 'EPG Service',
          key: 'EpgTask'
        }
      ]
    },
    {
      name: 'Devices',
      key: 'Device'
    },
    {
      name: 'Settings',
      children: [
        {
          name: 'General Settings',
          key: 'GlobalGeneral'
        }, {
          name: 'Payment Services',
          key: 'GlobalPayment'
        }, {
          name: 'Currencies',
          key: 'Currency'
        }, {
          name: 'Extensions',
          key: 'Extension'
        }, vm.APP_PRODUCT_TOUR_ENABLED && {
          name: 'Apps Settings',
          key: 'AppsSettings'
        }]
    },
    authSvc.hasEnabledFlag('FEATURE_APP_LOCALIZATION_ENABLED') && {
      name: 'App Localization',
      key: 'Localization'
    },
    {
      name: 'API Access',
      key: 'APIAccessGlobal'
    },
    {
      name: 'System Users',
      key: 'User'
    },
    authSvc.hasEnabledFlag('FEATURE_DISTRIBUTORS_ENABLED') && {
      name: 'Distributors',
      key: 'Distributor',
      children: [
        {
          name: 'Voucher Batches',
          key: 'VoucherBatch'
        }]
    },
    {
      name: 'Reports',
      // key: 'Report',
      children: [
        authSvc.hasEnabledFlag('FEATURE_SUBSCRIBER_REPORTS_ENABLED') && {
          name: 'Subscriber Reports',
          key: 'SubscriberReport'
        }, authSvc.hasEnabledFlag('FEATURE_SUBSCRIBER_ACTIVITY_REPORTS_ENABLED') && {
          name: 'Subscriber Activity Reports',
          key: 'SubscriberActivityReport'
        }, authSvc.hasEnabledFlag('FEATURE_CPS_REPORTS_ENABLED') && {
          name: 'CPS Reports',
          key: 'CpsReport'
        }, authSvc.hasEnabledFlag('FEATURE_STREAM_REPORTS_ENABLED') && {
          name: 'Stream Reports',
          key: 'StreamReport'
        }, authSvc.hasEnabledFlag('FEATURE_ACTIVATION_AUDIT_REPORTS_ENABLED') && {
          name: 'Activation Audit Reports',
          key: 'ActivationAuditReport'
        }, authSvc.hasEnabledFlag('FEATURE_TRANSACTIONAL_REPORTS_ENABLED') && {
          name: 'Transactions Report',
          key: 'TransactionReport'
        }, authSvc.hasEnabledFlag('FEATURE_FINANCIAL_REPORTS_ENABLED') && {
          name: 'Financial Reports',
          key: 'FinancialReport'
        }]
    },
    {
      name: 'DRM Service',
      key: 'DRM',
      children: [
        {
          name: 'DRM Accounts',
          key: 'DRMAccount'
        }, {
          name: 'DRM Profiles',
          key: 'DRMProfile'
        }]
    },
    {
      name: 'Geo Blocking',
      key: 'GeoBlocking'
    },
    {
      name: 'Stream Services',
      children: [
        authSvc.hasEnabledFlag('FEATURE_SETRIX_INTEGRATION_ENABLED') && {
          name: 'Setrix Server Settings',
          key: 'SetrixSettings'
        },
        authSvc.hasEnabledFlag('FEATURE_SETRIX_INTEGRATION_ENABLED') && {
          name: 'Transcoders',
          key: 'Transcoder'
        },
        authSvc.hasEnabledFlag('FEATURE_STREAM_SERVICES_ENABLED') && {
          name: 'Stream Service',
          key: 'StreamService'
        },
        {
          name: 'Streaming URL Policy',
          key: 'UrlPolicy'
        }
      ]
    }
  ]

  vm.expansedRule.forEach(er => {
    if (authSvc.hasEnabledFlag('FEATURE_NORA_CATCHUPS_ALLOWED_ENABLED') && er.name === 'Channels') {
      delete er.children
    }
    if (er.children) {
      er.children = er.children.filter(ch => ch !== false)
    }
  })
  vm.expansedRule = vm.expansedRule.filter(rule => rule)

  rule._expanse(vm.expansedRule)

  syncTranscoderCreateModifyAssignment()

  wireContentDeliveryPermissionRows()

  /**
   * Transcoder Create and Modify Assignment stay aligned: Create implies Modify Assignment;
   * turning off Modify Assignment clears Create.
   */
  function syncTranscoderCreateModifyAssignment () {
    const setrixRoot = find((r) => r.name === 'Stream Services')(vm.expansedRule)
    if (!setrixRoot || !setrixRoot.children || !setrixRoot.children.length) return

    const transcoder = setrixRoot.children.find((ch) => ch.key === 'Transcoder')
    if (!transcoder || transcoder.create === undefined) return

    if (transcoder.modifyAssignment !== undefined && !transcoder.modifyAssignment) {
      transcoder.create = false
    } else if (transcoder.modifyAssignment !== undefined && transcoder.create) {
      transcoder.modifyAssignment = true
    }
  }

  /**
   * Setrix Server Settings and Transcoders share VIEW_CONTENT_DELIVERY_SERVER on the API.
   * Keep the View (and Hide) columns in sync; transcoder uses modifyAssignment/runtimeControl vs setrix edit/delete.
   */
  function wireContentDeliveryPermissionRows () {
    const setrixRoot = find((r) => r.name === 'Stream Services')(vm.expansedRule)
    if (!setrixRoot || !setrixRoot.children || !setrixRoot.children.length) return

    const setrixSettings = setrixRoot.children.find((ch) => ch.key === 'SetrixSettings')
    const transcoder = setrixRoot.children.find((ch) => ch.key === 'Transcoder')
    if (!setrixSettings || !transcoder) return

    const linkedActions = ['view', 'hide']
    const origSetrix = setrixSettings.checkParity.bind(setrixSettings)
    const origTranscoder = transcoder.checkParity.bind(transcoder)

    function copyLinkedActionsToPeer (source, peer) {
      for (let i = 0; i < linkedActions.length; i++) {
        const action = linkedActions[i]
        if (source[action] !== undefined && peer[action] !== undefined) {
          peer[action] = source[action]
        }
      }
    }

    setrixSettings.checkParity = function (flag) {
      origSetrix(flag)
      copyLinkedActionsToPeer(setrixSettings, transcoder)
      origTranscoder(flag)
    }

    transcoder.checkParity = function (flag) {
      origTranscoder(flag)
      copyLinkedActionsToPeer(transcoder, setrixSettings)
      origSetrix(flag)
    }
  }

  /**
   * isNew flag
   *
   * @memberof mwApp/settings.controller:AddPermissionRuleCtrl
   * @type {Boolean}
   */
  vm.isNew = rule._isNew()

  // get networks
  $http.get('api/networks/list')
    .data()
    .except(rule.networks) // remove networks, already existed in rule
    .to(vm.networks = [])
    .then(() => {
      const existingNetworks = rule.networks.map(getId)
      vm.networks = [{ id: 0, name: 'All Organizations' }].concat(vm.networks.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)))
        .filter(n => existingNetworks.indexOf(n.id) === -1)
      if (!vm.isNew && !vm.rule.networks.length) { vm.networkSelected = vm.networks[0] }
      $scope.loading = false
    })

  /**
   *  Filter networkSets according available networks
   * @param pckg
   * @returns {Function}
   */
  vm.deselectPckg = function (pckg) {
    $scope.form.$setDirty()
    vm.deselectNetwork(pckg)
    vm.networks = [{ id: 0, name: 'All Organizations' }].concat(vm.networks.filter(n => n.id !== 0).sort((a, b) => {
      return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
    }))
  }

  /**
   * Add network to rule
   *
   * @memberof mwApp/settings.controller:AddPermissionRuleCtrl
   */
  vm.selectOrganization = function () {
    if (vm.networkSelected.id !== 0) {
      vm.selectNetwork(vm.networkSelected)
      // disable editing and removing packages if user has package permissions
      if (rule.networks.length) {
        const r = find(r => r.key === 'Network')(vm.expansedRule)
        r.delete = false
      }
      vm.networkSelected = null
    } else {
      const networks = angular.copy(vm.rule.networks)
      networks.forEach(network => {
        vm.deselectPckg(network)
      })
    }
  }

  /**
   * Create or edit rule
   *
   * @memberof mwApp/settings.controller:AddPermissionRuleCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    rule._reduction(vm.expansedRule, true)
      ._save()
      .then(vm.location(rule).reload)
      .catch(() => {})
      .finally(vm.unsetDisable)
  }

  vm.disabledByDepends = function () {
    const currentRule = rule._reduction(vm.expansedRule)
    const disableByDiscountCampaigns = currentRule.viewDiscountCampaigns && !(currentRule.viewSubscription && currentRule.viewNetwork && currentRule.editNetwork)
    const disableByLimitGeneralInfo = currentRule.limitGeneralInfoSubscriber && !currentRule.viewSubscriber
    return disableByDiscountCampaigns || disableByLimitGeneralInfo
  }

  /**
   * Delete rule
   *
   * @memberof mwApp/settings.controller:AddPermissionRuleCtrl
   */
  vm.deleteRule = function () {
    vm.setDisable()
    rule._delete()
      .then(vm.location(rule).list)
      .catch(() => {})
      .finally(vm.unsetDisable)
  }

  /**
   * Check flag enabled
   *
   * @param flag
   * @returns {Boolean}
   */
  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  /**
   * Find rule and permissions check
   *
   * @param permissionKeys {Array<string>}
   * @param ruleKey {String}
   * @returns {Boolean}
   */
  vm.hasPermissions = function (permissionKeys = [], ruleKey) {
    let rule = null
    for (let i = 0; i < vm.expansedRule.length; i++) {
      const r = vm.expansedRule[i]
      if (r.key === ruleKey) {
        rule = r; break
      } else if (r?.children?.length) {
        const cr = r.children.find((cr) => cr.key === ruleKey ? cr : null)
        if (cr) { rule = cr; break }
      }
    }

    return rule
      ? permissionKeys.filter((key) => Object.prototype.hasOwnProperty.call(rule, key) && !!rule[key]).length === permissionKeys.length
      : false
  }
}
